export default __webpack_public_path__ + "pizza.322fa715.jpg";